import { useAuthStore } from '@/domains/identity/store/authStore';

const DEV_EMAIL = 'hayleyabishop@gmail.com';

const buildTime = new Date(__BUILD_TIME__).toLocaleString('en-US', {
  timeZone: 'America/Chicago',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

export default function DevBuildBadge() {
  const email = useAuthStore((s) => s.user?.email);
  if (email !== DEV_EMAIL) return null;

  return (
    <div className="fixed top-2 right-2 z-50 text-xs text-neutral-400 bg-white/70 backdrop-blur-sm border border-neutral-200 rounded px-2 py-1 pointer-events-none select-none">
      published {buildTime} CT
    </div>
  );
}
